module.exports = AzureStorage.Blob;